<script lang="ts">
    import route from '../Util/routes';
    import type { MyFitnessStores } from './stores';
    import { challenge_n_days, cont_n_weeks } from '@/Common/constants';
    import { debouncer, getDateSliderColor } from '@/Util/utils';
    import { addDays, differenceInDays, fromUnixTime } from 'date-fns';

    export let myFitness: MyFitnessStores;
    export let athlete = "Puncheur";
    export let workout_description;
    export let program_weeks;
    export let challenge_days;
    export let atDate;

    //@ts-expect-error
    const Xert = window.Xert;
    //@ts-expect-error
    const jq = window.$;

    let root: HTMLElement;

    let slider: HTMLElement;
    let continuousSlider: HTMLElement;
    let challengeSlider: HTMLElement;

    let program_type;

    let _continuousLowerBound = null;
    let _continuousCurrLowerBound = null;
    let _continuousCurrSliderVal  = null;
    let _continuousWeeklyRequest = null;
    let _continuousWeeklyRequestPendingValue = null;

    let _challengeLowerBound = null;
    let _challengeCurrLowerBound = null;
    let _challengeCurrSliderVal  = null;
    let _challengeWeeklyRequest = null;
    let _challengeWeeklyRequestPendingValue = null;

    let getContinuousTrainingProgramDataURL = route('UserController@getContinuousTrainingProgramData');
    let getContinuousWeeklyHoursURL = route('UserController@getContinuousWeeklySummaryToView');
    let getContinuousProgramStatisticsURL = route('UserController@getContinuousProgramStatistics');

    let getChallengeTrainingProgramDataURL = route('UserController@getChallengeTrainingProgramData');
    let getChallengeWeeklyHoursURL = route('UserController@getChallengeWeeklySummaryToView');
    let getChallengeProgramStatisticsURL = route('UserController@getChallengeProgramStatistics');

    let getTrainingProgramDataURL = route('UserController@getTrainingProgramData');
    let getWeeklyHoursURL = route('UserController@getWeeklySummaryToView');

    let { trainingAdvice } = myFitness;

    function initSlider() {
        const parameters = {
            atDate: atDate?.toISOString()
        };
        if ($trainingAdvice && root) {
            program_type = $trainingAdvice.program.type;
        }

        switch (program_type) {
            case 'continuous':
                jq.getJSON(getContinuousTrainingProgramDataURL, parameters, function (data) {
                    populateContinuousSliderHTML(data);
                }.bind(this));
                jq.getJSON(getContinuousProgramStatisticsURL, function (data) {
                    updateContinuousSliderColour(data);
                }.bind(this));
                break;
            case 'challenge':
                jq.getJSON(getChallengeTrainingProgramDataURL, parameters, function (data) {
                    populateChallengeSliderHTML(data);
                }.bind(this));
                jq.getJSON(getChallengeProgramStatisticsURL, function (data) {
                    updateChallengeSliderColour(data);
                }.bind(this));
                break;
            case 'targetEvent':
                jq.getJSON(getTrainingProgramDataURL, parameters, function (data) {
                    populateSliderHTML(data);
                }.bind(this));
                break;
        }
    }

    $: {
            const parameters = {
                atDate: atDate?.toISOString()
            };
            switch(program_type){
                case 'targetEvent':
                    jq.getJSON(getTrainingProgramDataURL, parameters, function (data) {
                        populateSliderHTML(data);
                    });
                    break;
                case 'continuous':
                    jq.getJSON(getContinuousTrainingProgramDataURL, parameters, function (data) {
                        populateContinuousSliderHTML(data);
                    });
                    jq.getJSON(getContinuousProgramStatisticsURL, function (data) {
                        updateContinuousSliderColour(data);
                    });
                    break;
                case 'challenge':
                    jq.getJSON(getChallengeTrainingProgramDataURL, parameters, function (data) {
                        populateChallengeSliderHTML(data);
                    });
                    jq.getJSON(getChallengeProgramStatisticsURL, function (data) {
                        updateChallengeSliderColour(data);
                    });
                    break;
            }
            
        }

    function populateSliderHTML(data) {
        addAnimation('build_date_text');
        addAnimation('peak_date_text');
        addAnimation('target_date_text');
        build_date_text = data.build_date;
        peak_date_text = data.peak_date;
        target_date_text = data.event_date;

        const todayDateElem: HTMLElement = root.querySelector('#today_date')

        if (todayDateElem) {
            if (data.slider_val > 0) {
                const now = new Date();
                const planDate = fromUnixTime($trainingAdvice.target_event_timestamp)
                const planStartDate = addDays(planDate, -120)
                const todayIdx = differenceInDays(now, planStartDate)
                const sliderPercent = ((todayIdx+20) / 140) * 100
                const sliderOffset = (sliderPercent - 50)/5 + 1
                todayDateElem.style.left = `calc(${sliderPercent}% - ${sliderOffset}px`
            } else {
                const sliderOffset = (0 - 50)/5 + 1
                todayDateElem.style.left = `calc(0% - ${sliderOffset}px)`
            }
        }
        if (data.phase === 'Post Event') {
            root.querySelector('#training_program_widget').classList.add('hidden');
            document.getElementsByClassName('slider_container')[0].classList.add('hidden');
            root.querySelector('#post_event_text').classList.remove('hidden');
            post_event_weekly_hours = data.weekly_hours.toFixed(1);
        }
        updateWeekly(data);
        _lowerBound = 0;//lower bound is from the beginning of the slider, used
        updateWeeklySlider(data);
    }

    function updateWeeklySlider(data) {
        // Update slider position to match value in response data.
        _currSliderVal = data.slider_val;
    }

    $: if (_continuousCurrSliderVal != null && atDate != null) {
        fetchContinuousWeeklyInformation();
    }

    function fetchContinuousWeeklyInformation() {
        if (_continuousCurrSliderVal < _continuousCurrLowerBound) {
            _continuousCurrSliderVal = _continuousCurrLowerBound;
            return;
        } else if (_continuousCurrSliderVal > cont_n_weeks*2) {
            _continuousCurrSliderVal = cont_n_weeks*2;
            return;
        }
        const parameters = {
            'slider_val' : _continuousCurrSliderVal,
            'original_val' : _continuousLowerBound,
            'atDate': atDate.toISOString()
        };

        _continuousWeeklyRequestPendingValue = parameters;

        // Don't make new request if a request is being processed, othewise the server gets spammed with requests.
        if (_continuousWeeklyRequest) {
            return;
        }
        _continuousWeeklyRequest = jq.getJSON(getContinuousWeeklyHoursURL, parameters, function (data) {
            updateWeekly(data);
            _continuousWeeklyRequest = null;
            if (parameters != _continuousWeeklyRequestPendingValue) {
                // fetch more data from the server if the slider was moved while processing this request.
                fetchContinuousWeeklyInformation();
            } else {
                // Don't change slider position unless this response matches the most recent parameters.
                updateContinuousSlider(data);
            }
        }.bind(this));
    }

    function populateContinuousSliderHTML(data) {
        addAnimation('continuous_start_date_text');
        addAnimation('continuous_end_date_text');
        continuous_start_date_text = data.continuous_start_date;
        continuous_end_date_text = data.continuous_end_date;  

        if (data.slider_val > 0) {
            const sliderPercent = data.slider_val * 100 / (cont_n_weeks*2);
            const sliderOffset = (sliderPercent - 50)/5 + 1;
            root.querySelector<HTMLElement>('#today_date').style.left = `calc(${sliderPercent}% - ${sliderOffset}px`;
        } else {
            const sliderOffset = (0 - 50)/5 + 1;
            root.querySelector<HTMLElement>('#today_date').style.left = `calc(0% - ${sliderOffset}px)`;
        }

        updateWeekly(data);
        _continuousCurrLowerBound = data.slider_val;
        _continuousLowerBound = 0;
        updateContinuousSlider(data);
    }
    function updateContinuousSlider(data) {
        // Update slider position to match value in response data.
        if (data.slider_val != _continuousCurrSliderVal)
            _continuousCurrSliderVal = data.slider_val;
    }

    let continuousSliderStyle = '';
    function updateContinuousSliderColour(data) {
        // Update slider colour to match value in response data.
        
        continuousSliderStyle = getDateSliderColor(data, 50, 50);
    }

    $: if (_challengeCurrSliderVal != null && atDate != null) {
        fetchChallengeWeeklyInformation();
    }

    function fetchChallengeWeeklyInformation() {
        if (_challengeCurrSliderVal < _challengeCurrLowerBound) {
            _challengeCurrSliderVal = _challengeCurrLowerBound;
            return;
        } else if (_challengeCurrSliderVal > challenge_n_days ) {
            _challengeCurrSliderVal = challenge_n_days;
            return;
        }
        const parameters = {
            'slider_val' : _challengeCurrSliderVal,
            'original_val' : _challengeLowerBound,
            'atDate': atDate.toISOString()
        };

        _challengeWeeklyRequestPendingValue = parameters;

        // Don't make new request if a request is being processed, othewise the server gets spammed with requests.
        if (_challengeWeeklyRequest) {
            return;
        }
        _challengeWeeklyRequest = jq.getJSON(getChallengeWeeklyHoursURL, parameters, function (data) {
            updateWeekly(data);
            _challengeWeeklyRequest = null;
            if (parameters != _challengeWeeklyRequestPendingValue) {
                // fetch more data from the server if the slider was moved while processing this request.
                fetchChallengeWeeklyInformation();
            } else {
                // Don't change slider position unless this response matches the most recent parameters.
                updateChallengeSlider(data);
            }
        }.bind(this));
    }
    function populateChallengeSliderHTML(data) {
        addAnimation('challenge_start_date_text');
        addAnimation('challenge_end_date_text');
        challenge_start_date_text = data.challenge_start_date;
        challenge_end_date_text = data.challenge_end_date;


        if (data.slider_val > 0) {
            const sliderPercent = data.slider_val * 100 / 29;
            const sliderOffset = (sliderPercent - 50)/5 + 1;
            root.querySelector<HTMLElement>('#today_date').style.left = `calc(${sliderPercent}% - ${sliderOffset}px`;
        } else {
            jq('#challenge_start_date').addClass('hidden');
            const sliderOffset = (0 - 50)/5 + 1;
            root.querySelector<HTMLElement>('#today_date').style.left = `calc(0% - ${sliderOffset}px)`;
        }

        if (data.phase === 'Post Event') {
            root.querySelector('#training_program_widget').classList.add('hidden');
            document.getElementsByClassName('slider_container')[0].classList.add('hidden');
            root.querySelector('#post_event_text').classList.remove('hidden');
            post_event_weekly_hours = data.weekly_hours.toFixed(1);
        }
        updateWeekly(data);
        updateChallengeSlider(data);
        _challengeCurrLowerBound = data.slider_val;
        _challengeLowerBound = 0;
    }
    function updateChallengeSlider(data) {
        // Update slider position to match value in response data.
        _challengeCurrSliderVal = data.slider_val;
    }

    let challengeSliderStyle = '';
    function updateChallengeSliderColour(data) {
        // Update slider colour to match value in response data.
        
        const pcntDaysFilled = (data.length / 30) * 100;
        challengeSliderStyle = getDateSliderColor(data, pcntDaysFilled, pcntDaysFilled) // Only completed days are colored
    }

    $: if ($trainingAdvice && root) {
        program_type = $trainingAdvice.program.type;

        initSlider();
        initBadAdvisorData($trainingAdvice)
    }

    let _lowerBound = null;
    let _currSliderVal  = null;
    let _weeklyRequest = null;
    let _weeklyRequestPendingValue = null;



    let workout_name = "";
    let workout_desc = "";
    let weekly_hours_content = 0, week_start = 0, week_end = 0, program_phase_content, post_event_weekly_hours;
    let build_date_text, peak_date_text, target_date_text, continuous_start_date_text, continuous_end_date_text, challenge_start_date_text, challenge_end_date_text;

    function updateWeekly(data) {
            console.log('updateWeekly: ', data)
            // Update text labels to match value in response data.
            weekly_hours_content =  data.weekly_hours.toFixed(1);
            console.log('weekly hours content: ', {weekly_hours_content})
            week_start = data.week_start;
            week_end = data.week_end;
            if (program_type != 'continuous' && program_type != 'challenge')
                program_phase_content = data.phase;
            workout_name = data.workout_name;
            workout_desc = data.workout_desc;
        }

    const debounceFetchWeeklyInformation = debouncer(150)
    $: if (_currSliderVal != null) {
        fetchWeeklyInformation();
    }
    function fetchWeeklyInformation() {
        const now = new Date();
        const planDate = fromUnixTime($trainingAdvice.target_event_timestamp)
        const planStartDate = addDays(planDate, -120)
        const todayIdx = differenceInDays(now, planStartDate)
        // console.log({todayIdx, _currSliderVal, planDate, planStartDate, now, checkNow: addDays(planStartDate, todayIdx)})
        if (_currSliderVal < todayIdx) {
            _currSliderVal = todayIdx;
            return;
        } else if (_currSliderVal > 120) {
            _currSliderVal = 120;
            return;
        }
        const parameters = {
            'slider_val' : _currSliderVal,
            'original_val' : _lowerBound,
            'atDate': atDate?.toISOString(),
        };

        _weeklyRequestPendingValue = parameters;

        
        debounceFetchWeeklyInformation.debounce(() => jq.getJSON(getWeeklyHoursURL, parameters, function (data) {
            updateWeekly(data);
            _weeklyRequest = null;
            if (parameters != _weeklyRequestPendingValue) {
                // fetch more data from the server if the slider was moved while processing this request.
                fetchWeeklyInformation();
            } else {
                // Don't change slider position unless this response matches the most recent parameters.
                updateWeeklySlider(data);
            }
        }.bind(this)))
    }


    function addAnimation(id) {
        document.getElementById(id)?.classList?.add('fade_animation');
    }

    function initBadAdvisorData(trainingAdvice) {
        if (Xert.trickleIsProcessing) { return; } // Don't show any notification if trickle is processing.

        Xert.MyFitness.xataBadDataMessage = trainingAdvice.data_quality.message;

        if (Xert.getConfig('active_tab_controller') != 'advisor') { return; }

        if (!jq.isEmptyObject(trainingAdvice.data_quality)) {
            let x = trainingAdvice.data_quality.data_quality;
            let classHidden = '';
            let view = '';

            if (x == 'data_too_old') {
                view = '<strong>We suggest you reset your account and start over. <button class="btn btn-primary btn-xs" data-toggle="modal" data-target="#start_over_modal">click here</button></strong><hr>';
                classHidden = 'hidden';
            }

            else if (x == 'no_recent_data') {
                view = '<strong>Upload/Sync more activities:</strong></p>' +
                    '<ul>' +
                    '<li><a href="/activities/upload">Upload FIT/TCX files</a></li>' +
                    '<li><a href="/strava">Strava Sync</a></li>' +
                    '</ul><hr>';
                classHidden = 'hidden';
            } else {
                view = '';
            }

            jq('#training_advisor_block .bad-data-view').html(view).removeClass(classHidden);

            if (Xert.MyFitness.badDataNotifCount == 0) {
                Xert.MyFitness.showXataBadDataNotification();
            }

            Xert.MyFitness.badDataNotifCount = Xert.MyFitness.badDataNotifCount + 1;
        }
    }

</script>

<div bind:this={root} class="box-solid text-sm">
    <div class="portlet light portlet-fit bordered full-height-content full-height-content-scrollable training_program_body">
        <div class="portlet-title">
            <div class="title_container">
                <span class="box_header"> Adaptive Training Program
                <a href="https://baronbiosys.com/glossary/program-type/" target="_help">
                    <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span></span>
                </a>
                </span>
            </div>
        </div>
        {#if program_type == 'continuous'}
        <div class="portlet-body">
            <div class="slider_container">
                <span class="range_label_container">
                    <div id="today_date"></div>
                    <div id="continuous_start_date">
                        <span id="continuous_start_date_text">{continuous_start_date_text}</span>
                        <div class="circle"></div>
                    </div>
                    <div id="continuous_end_date">
                        <span id="continuous_end_date_text">{continuous_end_date_text}</span>
                        <div class="circle"></div>
                    </div>
                </span>
                <input bind:this={continuousSlider} style="background: {continuousSliderStyle}" type="range" class="continuous_slider" min="0" max={program_weeks} step="1" bind:value={_continuousCurrSliderVal}>
            </div>
        </div>
        <div class="portlet-body">
            <div id="training_program_widget">
                <div class="summary_container">
                    <span class="weekly_target">
                        <span>Weekly Target: </span>
                        <span id="week_start">{week_start}</span>
                        -
                        <span id="week_end">{week_end}</span>
                    </span>
                    <span>
                        <span id="workout_name" class="bold">{workout_name}</span>
                        <span>
                            - Focus Duration:
                            <span id="workout_desc">
                                    { workout_desc }
                            </span>
                        </span>
                    </span>
                </div>
                <div class="selector_widget">
                    <img on:click={()=> _continuousCurrSliderVal -= 1} src="/assets/images/arrow_left.svg">
                    <div class="weekly_selector_container">
                        <div class="widget_content">
                            <span class="widget_title">
                                <span>{weekly_hours_content}</span>
                                <span>hrs</span>
                            </span>
                            <span id="weekly_hours_title">Weekly Training Hours</span>
                        </div>
                        <div class="widget_content">
                            <span id="program_phase_content" class="widget_title" >Continuous</span>
                            <span id="program_phase_title">Program</span>
                        </div>
                    </div>
                    <img on:click={()=> _continuousCurrSliderVal += 1 } src="/assets/images/arrow_right.svg">
                </div>
            </div>
        </div>
        {:else if program_type == 'challenge'}
        <div class="portlet-body">
            <div class="slider_container">
                <span class="range_label_container">
                    <div id="today_date"></div>
                    <div id="challenge_start_date">
                        <span id="challenge_start_date_text">{challenge_start_date_text}</span>
                        <div class="circle"></div>
                    </div>
                    <div id="challenge_end_date">
                        <span id="challenge_end_date_text">{challenge_end_date_text}</span>
                        <div class="circle"></div>
                    </div>
                </span>
                <input bind:this={challengeSlider} style="background: {challengeSliderStyle}" type="range" class="challenge_slider" min="0" max={challenge_days} step="1" bind:value={_challengeCurrSliderVal}>
            </div>
        </div>
        <div class="portlet-body">
            <div id="training_program_widget">
                <div class="summary_container">
                    <span class="weekly_target">
                        <span>Weekly Target: </span>
                        <span id="week_start">{week_start}</span>
                        -
                        <span id="week_end">{week_end}</span>
                    </span>
                    <span>
                        <span id="workout_name" class="bold">{workout_name}</span>
                        <span>
                            - Focus Duration:
                            <span id="workout_desc">
                                    { workout_desc }
                            </span>
                        </span>
                    </span>
                </div>
                <div class="selector_widget">
                    <img on:click={()=> _challengeCurrSliderVal -= 1} src="/assets/images/arrow_left.svg">
                    <div class="weekly_selector_container">
                        <div class="widget_content">
                            <span class="widget_title">
                                <span>{weekly_hours_content}</span>
                                <span>hrs</span>
                            </span>
                            <span id="weekly_hours_title">Weekly Training Hours</span>
                        </div>
                        <div class="widget_content">
                            <span id="program_phase_content" class="widget_title" >Challenge</span>
                            <span id="program_phase_title">Program</span>
                        </div>
                    </div>
                    <img on:click={()=>_challengeCurrSliderVal += 1} src="/assets/images/arrow_right.svg">
                </div>
            </div>
            <div id="post_event_text" class="hidden">
                <div>
                    You have completed the 30 Day Challenge.
                    <br>
                    <br>
                </div>
                <div>
                    If you want to start a new challenge or change to continuous improvement, update your settings. 
                    <br>
                    <br>
                </div>
                <div>
                    Today's training required:
                    <span id="post_event_weekly_hours">{post_event_weekly_hours}</span>
                    <span>hrs</span>
                </div>
            </div>
        </div>
        {:else}
        <div class="portlet-body">
            <div class="slider_container">
                <span class="range_label_container">
                    <div id="today_date"></div>
                    <div id="build_date">
                        <span id="build_date_text">{build_date_text}</span>
                        <div class="circle"></div>
                    </div>
                    <div id="peak_date">
                        <span id="peak_date_text">{peak_date_text}</span>
                        <div class="circle"></div>
                    </div>
                    <div id="target_date">
                        <span class="upper_text">Target</span>
                        <span id="target_date_text">{target_date_text}</span>
                        <div class="circle"></div>
                    </div>
                </span>
                <input 
                    bind:this={slider} type="range" 
                    class="program_slider" 
                    min={-20} max="120" step="1" 
                    bind:value={_currSliderVal}
                >
                <span class="range_text_container">
                    <div id="pre_base">Pre-base</div>
                    <div id="base">Base</div>
                    <div id="build">Build</div>
                    <div id="peak">Peak</div>
                </span>
            </div>
        </div>
        <div class="portlet-body">
            <div id="training_program_widget">
                <div class="summary_container">
                    <span class="weekly_target">
                        <span>Weekly Target: </span>
                        <span id="week_start">{week_start}</span>
                        -
                        <span id="week_end">{week_end}</span>
                    </span>
                    <span>
                        <span id="workout_name" class="bold">{workout_name}</span>
                        <span>
                            - Focus Duration:
                            <span id="workout_desc">
                                    { workout_desc }
                            </span>
                        </span>
                    </span>
                </div>
                <div class="selector_widget">
                    <img on:click={()=> _currSliderVal -= 1} src="/assets/images/arrow_left.svg">
                    <div class="weekly_selector_container">
                        <div class="widget_content">
                            <span class="widget_title">
                                <span>{weekly_hours_content}</span>
                                <span>hrs</span>
                            </span>
                            <span id="weekly_hours_title">Weekly Training Hours</span>
                        </div>
                        <div class="widget_content">
                            <span id="program_phase_content" class="widget_title">{program_phase_content ? program_phase_content : "Base"}</span>
                            <span id="program_phase_title">Program Phase</span>
                        </div>
                    </div>
                    <img on:click={()=> _currSliderVal += 1} src="/assets/images/arrow_right.svg">
                </div>
            </div>
            <div id="post_event_text" class="hidden">
                <div>
                    You are in the Post Event phase of your plan.
                    <br>
                    <br>
                </div>
                <div>
                    If you have a new Target Event Date, update your settings. If you do not have another target event date,
                    Xert will continue to guide you to improve your fitness according to your selected improvement rate.
                    <br>
                    <br>
                </div>
                <div>
                    This week's training required:
                    <span id="post_event_weekly_hours">{post_event_weekly_hours}</span>
                    <span>hrs</span>
                </div>
            </div>
        </div>
        {/if}
    </div>
</div>